import state from "@/commons/store/flowbee/configuracao/state";
import actions from "@/commons/store/flowbee/configuracao/actions";
import mutations from "@/commons/store/flowbee/configuracao/mutations";

export default { state, actions, mutations }
